var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('mixer-loads-list'):_c('mixer-loads-list-mobile')}
var staticRenderFns = []

export { render, staticRenderFns }